import React, { useState } from "react";
import Card from "components/card";
import { IoAdd } from "react-icons/io5";
import AddInstallmentModal from "./AddInstallmentModal";

const InstallmentTable = ({ installments, onAddInstallment, canUpdate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const formatCurrency = (value) => {
    if (!value && value !== 0) return "-";
    return new Intl.NumberFormat("en-IN", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleSave = async (data) => {
    setIsSaving(true);
    try {
      await onAddInstallment(data);
      setIsModalOpen(false);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Card extra={"w-full h-full p-4"}>
      <div className="relative flex items-center justify-between">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          Payment Installments
        </div>
        {canUpdate && (
          <button
            onClick={() => setIsModalOpen(true)}
            className="flex items-center gap-2 rounded-lg bg-brand-500 px-3 py-1.5 text-sm font-medium text-white transition hover:bg-brand-600"
          >
            <IoAdd className="text-lg" />
            Add Installment
          </button>
        )}
      </div>

      <AddInstallmentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSave}
        isSaving={isSaving}
      />

      <div className="mt-4 overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr>
              <th className="border-b border-gray-200 pr-8 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">DATE</p>
              </th>
              <th className="border-b border-gray-200 pr-8 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">PARTICULAR</p>
              </th>
              <th className="border-b border-gray-200 pr-8 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">QTY</p>
              </th>
              <th className="border-b border-gray-200 pr-8 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">RATE</p>
              </th>
              <th className="border-b border-gray-200 pr-8 pb-[10px] text-start dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">AMOUNT</p>
              </th>
            </tr>
          </thead>
          <tbody>
            {installments && installments.length > 0 ? (
              installments.map((inst, index) => (
                <tr key={index}>
                  <td className="pt-[14px] pb-3 text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {formatDate(inst.date)}
                    </p>
                  </td>
                  <td className="pt-[14px] pb-3 text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {inst.explanation}
                    </p>
                  </td>
                  <td className="pt-[14px] pb-3 text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {inst.quantity ? `${inst.quantity} ${inst.unit || ""}`.trim() : "-"}
                    </p>
                  </td>
                  <td className="pt-[14px] pb-3 text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {formatCurrency(inst.rate)}
                    </p>
                  </td>
                  <td className="pt-[14px] pb-3 text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {formatCurrency(inst.amount)}
                    </p>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="py-4 text-center text-sm text-gray-500">
                  No installments added yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Card>
  );
};

export default InstallmentTable;
